import type { Vessel } from '@greywing-maritime/frontend-library/dist/types/flotillaVesselTypes';

export function getVesselById(vessels: Map<number, Vessel>, id: number) {
  if (vessels) {
    return vessels.get(id);
  } else {
    return undefined;
  }
}
